import makeGuid from '@util/guid';
import {SITE_URL} from '@util/URLUtils';

const i18nText = upi.i18n.getTextFromKey;

export const printButton = ( label = 'Print', classList = '' ) => {
    return `
        <button type="button" role="button" tabIndex="0" class="button secondary print ${classList}" title="${label}"><i class="icon-print"></i> ${label}</button>
    `;
};

export const loginButton = ( label = '', redirectTo ) => {
    // strip the default page redirect
    const loginUrl = upi.paths.LOGIN_URL.replace(
        /page=\/[\w+\d+\.\+%-]+&?/,
        ''
    );
    const redirectUrl = redirectTo || window.location.pathname + window.location.search;

    return `<a class="button secondary signin-button"
        href="${loginUrl}?redirect=${encodeURIComponent( redirectUrl )}">
        ${label} <i class="icon-user"></i>
        sign in
    </a>`;
};

export const noCookieDialog =
    `<div id="noCookies">
        <header class="modal-header">
            <h1 class="h1">${i18nText( 'lbl-CookiesAreRequired', 'Cookies are needed for this feature' )}</h1>
        </header>
        <section class="modal-body">
            <p>${i18nText( 'lbl-CookiesBlocked', 'Your browser is currently set to block cookies.' )}</p>
            <p class="mt-4">${i18nText( 'lbl-WhyCookies-',
        'Cookies are small text files which are stored on your computer. We use cookies to tell us when you are logged in and help remember what is in your shopping cart. In order to take advantage of this feature please enable cookies.' )}</p>
            <p class="mt-4">${i18nText( 'lbl-AllowCookies',
        'To learn how to allow cookies, check the online help in your web browser.' )}</p>
        </section>
    </div>`;

export const viewDistributorsButton =
    `<a href="${SITE_URL}resources/distributors" class="button secondary">
        ${upi.i18n.getTextFromKey( 'lbl-seeDistributors', 'See distributors' )}
    </a>`;

export const contenteditable = ( maxlength = 18 ) => {
    const guid = 'editable-' + makeGuid();
    return `
        <div contenteditable="true" spellcheck="false" data-maxlength="${maxlength}" id="${guid}" data-name="${guid}"></div>
    `;
};

export const processOrderDialog = ( msg ) => {
    return `
    <div id="upi-dialog" class="process-order">
        <div id="upi-dialog-wrapper">
            <div class="upi-dialog-content">
                <h2 class="loading">${msg || 'Processing Order'}</h2>
                <p>Please do not click back or refresh your browser as it may result in an error.</p>
            </div>
        </div>
    </div>`;
};

export const intlNewsletterDialog = ( {modal, formId, portalId} ) => {
    if ( !formId || !portalId ) {
        return `
            <div>
                <header class="modal-header">
                    <h2 class="text-lg">Sorry, we're experiencing an issue</h2>
                </header>
                <section class="modal-body">
                 There was an unexpected issue on our end and we are unable to complete your request at this time.
                 Please try again later.
                </section>
                <section class="modal-footer flex justify-center">
                    <button class="button tertiary" data-modal-close>OK</button>
                </section>
            </div>
        `
    }

    upi.loadScriptAsync( '//js.hsforms.net/forms/v2.js', {
        onLoad: () => {
            hbspt.forms.create( {
                portalId,
                formId,
                target: '#eu-newsletter-dialog',
                onFormReady: () => {
                    $( '#eu-newsletter-dialog' ).removeClass( 'visually-hidden' );
                    setTimeout( modal.center, 0 );
                }
            } );
        }
    } );

    return `
    <div>
        <section id="eu-newsletter-dialog" class="modal-body visually-hidden"></section>
    </div>`;
};

export const paymentServiceUnavailable = () => {
    return `
        <div class="leading-tight">
            <h2 class="my-4 text-lg">Sorry, we are unable to accept new credit cards at the moment.</h2>
            <p class="mb-4 text-grey-dark">We are working on resolving a problem with our Payment Service Provider which is
                preventing us from accepting new cards at this time.</p>
            <p class="mb-4 text-grey-dark">If you need to add a credit card to complete your payment please 
                contact our Customer Support team by calling <b class="text-grey-darker whitespace-no-wrap">${upi.conf.phoneTollFree}</b>
            </p>
            <p class="p-4 bg-moon-grey rounded mt-6 text-grey-dark text-sm">
                Note &ndash; Some ad blockers may interfere with this payment feature. If you are using an ad blocker please consider 
                disabling it for this page.
            </p>
        </div>
    `;
};

export const paymentServiceUnavailableTAM = () => {
    return `
        <div class="leading-tight">
            <h2 class="my-4 text-lg">Sorry, for increased security we only allow the customer to add new payment methods</h2>
            <p class="mb-4 text-grey-dark">Please complete your order by using one of the existing payment options if available.</p>
            <p class="mb-4 text-grey-dark">If your client needs to add a new credit card please ask them to sign in under their own credentials or have them call Customer Service.</p>
        </div>
    `;
};